(function($) {
  var fadeInDelay = 2000;

  $(function() {
    var $cta = $('.cta');
    
    if($cta.length <  1) {
      return;
    }

    setTimeout(function() {
      $cta.removeClass('cta--hidden');
    }, fadeInDelay);

    $('.cta__text').click(function() {
      $('.rental-area__toplink').removeClass('rental-area__toplink--hidden');
      $('.rental-area__toplink').click(function() {
        setTimeout(function() {
          $('.rental-area__toplink').addClass('rental-area__toplink--hidden');
        }, 1000);
      })
    });

    $('.cta__close').click(function() {
      $cta.addClass('cta--hidden');
    });
  });
})(jQuery);
